import Swiper, {Pagination} from 'swiper';
Swiper.use([Pagination]);

export default function InitSliders() {
	const swiperContainers = document.querySelectorAll('.swiper-container');
	if (swiperContainers.length === 0) return;

	if (!window.swipers || Array.isArray(window.swipers)) window.swipers = [];

	swiperContainers.forEach((swiperContainer) => {
		let options = {
			slidesPerView: 1,
			spaceBetween: 20,
		};

		swiperContainer.classList.forEach((currentClass) => {
			let addedOptions;

			switch (currentClass) {
				case 'paginated':
					addedOptions = {
						pagination: {
							el: '.swiper-pagination',
							clickable: true,
							dynamicBullets: true,
							dynamicMainBullets: 3,
						}
					};
					break;
				case 'thirds':
					addedOptions = {
						breakpoints: {
							768: {
								slidesPerView: 2,
								spaceBetween: 30,
							},
							1024: {
								slidesPerView: 3,
								spaceBetween: 50,
							},
							1366: {
								slidesPerView: 3,
								spaceBetween: 60
							}
						}
					};
					break;
			}

			Object.assign(options, addedOptions);
		});

		window.swipers.push(new Swiper(swiperContainer, options));
	});
}
